import React, { useState } from "react";
import { translate, textTranslate } from "../../utils/i18n";
import { Form, Button, Row, Col, FormGroup, Label, Input, FormText } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";

import * as CounterDashboardActions from "../../redux/actions/CounterDashboardActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const CounterServiceThresholdComp = props => {
  const [openSetNewThreshold, setOpenSetNewThreshold] = useState(false);
  const [serviceThresholdObj, setServiceThresholdObj] = useState({
    serviceTargetCount:
      props.DevicesData.hasOwnProperty("serviceSchedule") &&
      props.DevicesData.serviceSchedule !== null &&
      props.DevicesData.serviceSchedule.hasOwnProperty("serviceTargetCount")
        ? props.DevicesData.serviceSchedule.serviceTargetCount
        : null,
    notificationEmail:
      props.DevicesData.hasOwnProperty("serviceSchedule") &&
      props.DevicesData.serviceSchedule !== null &&
      props.DevicesData.serviceSchedule.hasOwnProperty("notificationEmail")
        ? props.DevicesData.serviceSchedule.notificationEmail
        : ""
  });
  const handleOpenSetNewThreshold = () => {
    setOpenSetNewThreshold(!openSetNewThreshold);
  };
  const handleSubmitNewThreshold = () => {
    props.SetNewThreshold(props.orgGroups, props.selectedOrganization, serviceThresholdObj, props.DevicesData).then(response => {
      if (response.case) {
        setOpenSetNewThreshold(!openSetNewThreshold);
        toast.success(translate("SetNewThresholdSuccessfully"));
        props.RemoveFromTrendsDevicesData(props.orgGroups, props.DevicesData);
          props.UpdateOneServiceSchedulingDevicesData(
            props.orgGroups,
            props.selectedDate,
            props.selectedPeriod,
            props.DeviceGroup,
            props.DevicesData,
            props.selectedOrganization
          );
      } else {
        toast.error(response.msg.response.data.error);
      }
    });
  };
  const changeValue = e => {
    setServiceThresholdObj({
      ...serviceThresholdObj,
      [e.target.name]: e.target.value
    });
  };

  const containerStyle = {
    zIndex: 999,
    marginTop: "40px"
  };

  return (
    <React.Fragment>
      <ToastContainer position="top-right" autoClose={5000} style={containerStyle} />
      {openSetNewThreshold ? (
        <Form onSubmit={handleSubmitNewThreshold}>
          <Row>
            <Col xs={props.isBigCard ? 3 : 12}>
              <FormGroup>
                <Label for="exampleNumber">{translate("serviceThreshold")}</Label>
                <Input
                  type="number"
                  name="serviceTargetCount"
                  value={serviceThresholdObj.serviceTargetCount || ''}
                  id="exampleNumber"
                  placeholder={textTranslate("serviceThresholdPlaceholder")}
                  onChange={e => {
                    if (e.target.value >= 0) changeValue(e);
                  }}
                />
              </FormGroup>
            </Col>
            <Col xs={props.isBigCard ? 9 : 12}>
              <FormGroup>
                <Label for="exampleEmail">{translate("notificationEmails")}</Label>
                <Input
                  type="email"
                  name="notificationEmail"
                  value={serviceThresholdObj.notificationEmail}
                  id="exampleEmail"
                  placeholder=""
                  onChange={changeValue}
                />
                <FormText>{translate("useSemicolon")}</FormText>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <Button outline block color="secondary" className="nounderline lead pl-0" onClick={handleOpenSetNewThreshold}>
                {translate("cancel")}
              </Button>
            </Col>
            <Col xs={6}>
              <Button
                block
                color="primary"
                className="nounderline lead pl-0"
                onClick={handleSubmitNewThreshold}
                disabled={serviceThresholdObj.serviceTargetCount <= 0}
              >
                <i className="fa fa-check mr-2" /> {translate("apply")}
              </Button>
            </Col>
          </Row>
        </Form>
      ) : (
        <Button color="link" className="nounderline lead pl-0" size="lg" onClick={handleOpenSetNewThreshold}>
          <i className="fa fa-pencil mr-2" /> {translate("setnewThreshold")}
        </Button>
      )}
    </React.Fragment>
  );
};
const mapStateToProps = state => ({
  orgGroups: state.CounterDashboardReducer.orgGroups,
  selectedOrganization: state.CounterDashboardReducer.selectedOrganization,
  selectedDate: state.CounterDashboardReducer.selectedDate,
  selectedPeriod: state.CounterDashboardReducer.selectedPeriod
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ ...CounterDashboardActions }, dispatch);
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CounterServiceThresholdComp);
